<div class="char-block">
  <h2 class="title">
    {{ "ANALYTICS_PAGE.SUPPROT" | translate }}
  </h2>

  <hr />

  <div style="max-width: 100%; height: 235px; margin: 0 auto">
    <canvas id="doughnut"></canvas>
  </div>

  <div class="legend">
    <div class="new">
      <span class="round">
        {{ "ANALYTICS_PAGE.SUPPORT_NEW" | translate }}
      </span>
      <span class="value">{{ supportData?.new_counter }}</span>
    </div>
    <div class="process">
      <span class="round">
        {{ "ANALYTICS_PAGE.SUPPORT_IN_PROCESS" | translate }}
      </span>
      <span class="value">{{ supportData?.in_process_counter }}</span>
    </div>
    <div class="solved">
      <span class="round">
        {{ "ANALYTICS_PAGE.SUPPORT_VIEWED" | translate }}
      </span>
      <span class="value">{{ supportData?.solved_counter }}</span>
    </div>
  </div>
</div>
